var Tool = {
  addEventHandler: (target, type, fn) => {
    if (target.addEventListener) {
      target.addEventListener(type, fn);
    } else {
      target.attachEvent('on' + type, fn);
    }
  },
  removeEventHandler: (target, type, fn) => {
    if (target.removeEventListener) {
      target.removeEventListener(type, fn);
    } else {
      target.detachEvent('on' + type, fn);
    }
  },
  // 判断是安卓还是苹果
  dateFormat_new: (second_obj, second_now) => {
    const userAgent = ()  => {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        return 0;
      } else if (/(Android)/i.test(navigator.userAgent)) {
        return 1;
      }
    }
    console.log(window.moment)
    var second = second_obj;
    if(userAgent() === 0) {
      second = second_obj.replace(/-/g, '/')
    }
    if (typeof second_obj === 'string') {
      // second = new Date(second_obj).getTime() / 1000;
      second = window.moment(second_obj).valueOf() / 1000
    }
    if (!second_now) {
      // second_now = Math.round(new Date().getTime() / 1000)
      second_now = Math.round(window.moment().valueOf() / 1000)
    }

    var time_sub = second_now - second; //时间差

    var year_time = 365 * 24 * 60 * 60;
    var month_time = 30 * 24 * 60 * 60;
    var day_time = 24 * 60 * 60;
    var hour_time = 60 * 60;
    var min_time = 60;


    var year = Math.floor(time_sub / year_time);
    var month = Math.floor((time_sub - year * year_time) / month_time);
    var day = Math.floor((time_sub - year * year_time - month * month_time) / day_time);
    var hour = Math.floor((time_sub - year * year_time - month * month_time - day * day_time) / hour_time);
    var min = Math.floor((time_sub - year * year_time - month * month_time - day * day_time - hour * hour_time) / min_time);

    return year > 0 ? (year + "年之前") : (month > 0 ? (month + "月之前") : (day > 0 ? (day + "天之前") : (hour > 0 ? (hour + "小时之前") : (min > 0 ? (min + "分钟之前") : "刚刚"))))
  },
  isIOS: () => {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      return true
    } else {
      return false
    }

  },
  isAndroid: () => {
    if (/(Android)/i.test(navigator.userAgent)) {
      return true;
    } else {
      return false
    }
  },
  isWeiXin: () => {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) === 'micromessenger') {
      return true;
    } else {
      return false;
    }
  },
  is_dongcheng: function () {
    return /北京东城/i.test(navigator.userAgent);
  },
  // 获取页面中url参数
  getParams: function (url) {
    if (!url) {
      url = window.location.hash;
    }
    const theRequest = {};
    const start = url.lastIndexOf("?");
    if (start !== -1) {
      const str = url.substr(start + 1);
      const strs = str.split("&");
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
      }
    }
    return theRequest;
  },
  // 移除 storage 的用户信息
  removeUserData: function () {
    localStorage.removeItem('zishengCMS_userInfo');
  },
  //秒转化成 分秒 00: 00
  secondToMS: (seconds,type) => {
    let m = Math.floor((seconds / 60 % 60)).toString();
    let s = Math.floor((seconds % 60)).toString();
    if (m.length < 2) {
      m = '0' + m;
    };
    if (s.length < 2) {
      s = '0' + s;
    };
    return m + ':' + s
  },
}

export default Tool;


// WEBPACK FOOTER //
// ./src/utils/tool.js